import { getCookie, setCookie } from "./crossCookie";
export const TARGET_ALERT_NOTIFICATIONS_COOKIES = "showNotifications";
const SEVEN_DAYS = 7;

export class NotificationsCookies {
  static DAYS_EXPIRED_COOKIE = SEVEN_DAYS;

  static insert(value) {
    const isDev = window.location.host.includes("localhost");

    setCookie(TARGET_ALERT_NOTIFICATIONS_COOKIES, value, SEVEN_DAYS, {
      domain: !isDev ? ".claro.com.br" : undefined,
      path: "/",
      secure: !isDev,
      sameSite: "Lax",
    });
  }

  static get() {
    return getCookie(TARGET_ALERT_NOTIFICATIONS_COOKIES);
  }
}
